export default class Header {
  constructor() {
    this.overlay = $('.l-headerOverlay');
    this.init();
  }
  init() {
    $('.js-toggleBtn').on({
      'mouseenter': () => {
        this.overlay.addClass('is_active')
      },
      'mouseleave': () => {
        this.overlay.removeClass('is_active')
      }
    })
  }
}
